import React from 'react';

import Button from '../../../components/ui/Button';
import Icon from '../../../components/ui/AppIcon';

import PressureHysteresisForm from './PressureHysteresisForm';

const StandardComparisonForm = ({ formState, formActions }) => {
  const { setpoint, resolution, k, readings } = formState;
  const {
    setSetpoint,
    setResolution,
    setK,
    addReading,
    removeReading,
    updateReading,
  } = formActions;

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div>
          <label>Setpoint</label>
          <input
            type="number"
            className="w-full border rounded p-2"
            value={setpoint}
            onChange={(e) => setSetpoint(e.target.value)}
          />
        </div>
        <div>
          <label>Resolución</label>
          <input
            type="number"
            className="w-full border rounded p-2"
            value={resolution}
            onChange={(e) => setResolution(e.target.value)}
          />
        </div>
        <div>
          <label>k</label>
          <input
            type="number"
            className="w-full border rounded p-2"
            value={k}
            onChange={(e) => setK(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-2 flex justify-between items-center">
        <label className="text-sm font-medium">Lecturas</label>
        <Button size="sm" variant="outline" onClick={addReading}>
          <Icon name="Plus" size={14} className="mr-1" /> Agregar
        </Button>
      </div>

      {readings.map((v, i) => (
        <div key={i} className="flex items-center gap-2 mb-2">
          <span className="w-24 text-sm">Medición {i + 1}</span>
          <input
            type="number"
            className="flex-1 border rounded p-2"
            value={v}
            onChange={(e) => updateReading(i, e.target.value)}
          />
          <button type="button" onClick={() => removeReading(i)} disabled={readings.length <= 1}>
            <Icon name="X" size={16} />
          </button>
        </div>
      ))}
    </>
  );
};

export default function MeasurementForm({ activeBlock, formState, formActions }) {
  if (!activeBlock) {
    return (
      <div className="text-sm text-muted-foreground border rounded p-3 mb-6">
        Primero crea y selecciona un bloque de prueba.
      </div>
    );
  }

  const blockType = activeBlock.block_type || activeBlock.mode;
  switch (blockType) {
    case 'pressure_hysteresis':
      return <PressureHysteresisForm formState={formState} formActions={formActions} />;
    case 'dimensional_comparison':
    case 'force_comparison':
    case 'standard_comparison':
    default:
      return <StandardComparisonForm formState={formState} formActions={formActions} />;
  }
}
